import React from "react";
import '../../CSS/Faqs/faqs.css';

const Faqs = () => {

    return (
        <div className="faqs">
            <h1>Frequently Asked Questions </h1>
            <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            <strong> Q1. </strong> What information should I include in my collaboration request to NUST Faculty members?
                        </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <strong>A1. </strong> The collaboration request should be clear and concise outlining the intent of collaboration, its outcomes, points of collaborations and other information deemed important for the faculty member should be included from the collaborator.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            <strong> Q2. </strong> How does a NUST faculty member update his or her NUST researcher profile?
                        </button>
                    </h2>
                    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <strong>A2. </strong> The Researcher profile is directly linked to the NUST Research Portal (NRP) database. To include any updates/changes in the profile or data, please get in touch with the Research Directorate,.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingThree">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            <strong>Q3. </strong> What if I can't find a researcher in my field of interest?
                        </button>
                    </h2>
                    <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <strong>A3. </strong> If you are unable to find the researcher of interest, we recommend trying to broaden the search such as adjusting the keywords, breaking down the keyword, entering a simpler keyword, or you can reach out to the administrator for assistance on collaboration@nust.edu.pk.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFour">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                            <strong>Q4. </strong> Is the platform open for searcher to researchers and industrialist from all disciplines?
                        </button>
                    </h2>
                    <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <strong>A4. </strong> 
                            Yes, the platform is open to researchers & industrialists from all the disciplines at NUST and they can use this portal to create effective collaborations.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFive">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                            <strong>Q5. </strong> Are there any guidelines for ethical collaboration and data sharing on the platform?
                        </button>
                    </h2>
                    <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <strong>A5. </strong> 
                            The portal complies with NUST guidelines.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="heading6">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse6" aria-expanded="true" aria-controls="collapse6">
                            <strong> Q6. </strong> Is the platform secure and compliant with data protection regulations?
                        </button>
                    </h2>
                    <div id="collapse6" className="accordion-collapse collapse show" aria-labelledby="heading6" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <strong>A6. </strong> Yes, the portal is secure and compliant with data protection regulations.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="heading7">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                            <strong> Q7. </strong> How do I create an account on the platform?
                        </button>
                    </h2>
                    <div id="collapse7" className="accordion-collapse collapse" aria-labelledby="heading7" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <strong>A7. </strong> An account can only be created for a NUST faculty member which is created automatically on the portal once he/she enters their research data into the NUST Research Portal. An account for the portal can only be created for the NUST Faculty members.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="heading8">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
                            <strong>Q8. </strong> Is there a fee to use the research platform?
                        </button>
                    </h2>
                    <div id="collapse8" className="accordion-collapse collapse" aria-labelledby="heading8" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <strong>A8. </strong> No, the platform is free for everyone to search.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="heading9">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse9" aria-expanded="false" aria-controls="collapse9">
                            <strong>Q9. </strong> How do I know if a researcher is interested in collaborating?
                        </button>
                    </h2>
                    <div id="collapse9" className="accordion-collapse collapse" aria-labelledby="heading9" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <strong>A9. </strong> 
                            We recommend contacting the researcher through his email address  given in his profile the portal for any prospective collaboration opportunities.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="heading10">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse10" aria-expanded="false" aria-controls="collapse10">
                            <strong>Q10. </strong> Is there a way to provide feedback or suggest improvements for the platform?
                        </button>
                    </h2>
                    <div id="collapse10" className="accordion-collapse collapse" aria-labelledby="heading10" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <strong>A10. </strong> 
                            The feedback can be provided using the Contact Us button on the portal and emailing on collaboration@nust.edu.pk.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="heading11">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse11" aria-expanded="false" aria-controls="collapse11">
                            <strong>Q11. </strong> Can I browse through publications or research papers of researchers on the platform?
                        </button>
                    </h2>
                    <div id="collapse11" className="accordion-collapse collapse" aria-labelledby="heading11" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <strong>A11. </strong> 
                            Yes, the research publications or projects can be accessed through the faculty profile and the weblink is provided for each publication.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="heading12">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse12" aria-expanded="false" aria-controls="collapse12">
                            <strong>Q12. </strong> How can I use the CollaborateAI Chatbot?
                        </button>
                    </h2>
                    <div id="collapse12" className="accordion-collapse collapse" aria-labelledby="heading12" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <strong>A12. </strong> 
                            The CollaborateAI chatbot can be used by selecting the option of CollaborateAI , selecting the sub options and then asking the question based upon the sub option.
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="heading13">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse13" aria-expanded="false" aria-controls="collapse13">
                            <strong>Q13. </strong> Who can I visit to enquire about a faculty member or research related matters?
                        </button>
                    </h2>
                    <div id="collapse13" className="accordion-collapse collapse" aria-labelledby="heading13" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <strong>A13. </strong> 
                            The matter can be enquired by visiting the Research Dte Office at Office of Research, Innovation and Commercialization, National University of Sciences and Technology (NUST). The Google location of the Research Dte is share in the Contact US.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Faqs;